import { Injectable } from '@angular/core';
import { Event, NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { NavItem } from '../layouts/full/sidebar/nav-item/nav-item';
@Injectable({ providedIn: 'root' })
export class NavService {

  public currentUrl = new BehaviorSubject<any>(undefined);

  // ✅ Add this property to store your menu structure dynamically
  public navItems: NavItem[] = [];

  constructor(private router: Router) {
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        this.currentUrl.next(event.urlAfterRedirects);
      }
    });
  }
}
